import { Box, Typography } from "@mui/material";
import { Decimal } from "@prisma-local/client/runtime/library";
import PropTypes from "prop-types";

interface LiftPillProps {
  value: number | string | null | Decimal;
  color: string;
  backgroundColor: string;
  fontSize?: string;
  width?: number;
}

const LiftPill: React.FC<LiftPillProps> = ({
  value,
  color,
  backgroundColor,
  fontSize,
  width,
}) => (
  <Box
    sx={{
      minWidth: 130,
      width: width || "auto",
      px: 4,
      py: 1.5,
      borderRadius: "25px",
      backgroundColor: backgroundColor,
      boxShadow: "0 10px 25px rgba(0,0,0,0.35)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      opacity: 1,
    }}
  >
    <Typography
      variant="h4"
      sx={{
        color: color,
        fontWeight: 800,
        textAlign: "center",
        fontSize: fontSize || "2.125rem",
      }}
    >
      {value ?? "-"}
    </Typography>
  </Box>
);

LiftPill.propTypes = {
  value: PropTypes.any.isRequired,
  color: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  fontSize: PropTypes.string,
  width: PropTypes.number,
};

export default LiftPill;
